import React from 'react';
import { Menu } from 'evergreen-ui';

const SourceMenu = ({
  onEditClick,
  onDeleteClick,
  onManageVersionsClick
}: any) => {
  return (
    <Menu>
      <Menu.Group>
        <Menu.Item onSelect={onEditClick}>Edit source</Menu.Item>
      </Menu.Group>
      <Menu.Divider />
      <Menu.Group>
        <Menu.Item onSelect={onManageVersionsClick}>Manage versions</Menu.Item>
      </Menu.Group>
      <Menu.Divider />
      <Menu.Group>
        <Menu.Item intent="danger" onSelect={onDeleteClick}>
          Delete source...
        </Menu.Item>
      </Menu.Group>
    </Menu>
  );
};

export default SourceMenu;
